import React, { lazy, type ComponentType } from 'react'
import { useTranslation } from 'react-i18next'
import { Button, EmptyState, Illustration } from '@node-space/ui-components'
import { logError } from '@node-space/utils'

const handleReload = () => globalThis.location.reload()

interface MFELazyOptions {
  mfeName: string
  testId: string
}

export function createMFELazy<Props>(
  importFn: () => Promise<{ default: ComponentType<Props> }>,
  { mfeName, testId }: MFELazyOptions
) {
  return lazy(() =>
    importFn()
      .catch(async (error: unknown) => {
        logError(`Failed to load ${mfeName} MFE, retrying in 2s...`, error)
        await new Promise(resolve => setTimeout(resolve, 2000))
        return importFn()
      })
      .catch((error: unknown) => {
        logError(`Failed to load ${mfeName} MFE after retry:`, error)
        const ErrorFallback: ComponentType<Props> = () => {
          const { t } = useTranslation()
          return (
            <EmptyState
              testId={testId}
              title={t('errorMessages.mfeLoadError')}
              description={t('errorMessages.mfeLoadErrorDescription')}
              Illustration={<Illustration name="Warning" />}
              PrimaryButton={<Button onClick={handleReload}>{t('errorMessages.retry')}</Button>}
            />
          )
        }
        return { default: ErrorFallback }
      })
  )
}
